import React from "react"
import Select from "react-select"
import classes from "./CustomSelect.module.scss"
import './CustomSelect.scss'

interface ICustomSelectProps {
  name?: string
  label?: string
  className?: string
  required?: boolean
  valid?: boolean
  shouldValidate?: boolean
  errorMessage?: string
  options?: any
  value: any
  defaultValue?: {label: string, value: string}
  onChange?: any
  isSearchable?: boolean
  placeholder?: string
  disabled?: boolean
  noOptionsMessage?: ((obj: {inputValue: string}) => React.ReactNode) | undefined
  isLoading?: boolean
  maxMenuHeight?: number
}

function CustomSelect({
    label,
    className,
    required,
    valid,
    shouldValidate,
    errorMessage,
    disabled,
    ...rest
  }: ICustomSelectProps) {

  let cls = [classes.wrap]
  let containerCls = ["custom-select-container"]

  if (className) {
    cls.push(className)
  }

  if (!valid && shouldValidate) {
    cls = [...cls, classes.error]
    containerCls = [...containerCls, "custom-select-container__error"]
  }

  if (required) {
    cls = [...cls, classes.required]
  }

  const labelTemplate = label ? <label className={classes.label}>{label}</label> : null
  const errorMessageTemplate = errorMessage && <span className={classes.error_message}>{errorMessage}</span>

  return (
    <div className={cls.join(" ")}>
      <div className={classes.container}>
        {labelTemplate}
        <Select
          className={containerCls.join(" ")}
          classNamePrefix={"custom-select"}
          isDisabled={disabled}
          noOptionsMessage={() => ("Совпадений не найдено")}
          {...rest}
        />
      </div>
      {errorMessageTemplate}
    </div>
  )
}

export default CustomSelect